import type { DEFAULT_SOUND_URLS } from "./data";

export interface PlaceholderSound {
  id: string;
  name: string;
  type: "placeholder";
}

export interface Sound {
  defaultSoundId?: keyof typeof DEFAULT_SOUND_URLS;
  historyItemId?: string;
  id: string;
  isLooped?: boolean;
  name: string;
  savedSoundId?: string;
  type: "sound";
  url: string;
}

export enum PresetCategory {
  DEFAULTS = "defaults",
  OWN = "own",
}

export type SoundSlot = PlaceholderSound | Sound;

export interface ApiPreset {
  icon: string;
  name: string;
  sounds: Required<Pick<Sound, "defaultSoundId" | "name" | "url">>[];
}

export interface Preset {
  hasEdits: boolean;
  icon: string;
  id: string;
  isCreatedByMe?: boolean;
  isPublic: boolean;
  loaded: boolean;
  name: string;
  savedBoardId?: string;
  sounds: SoundSlot[];
}

export interface SoundMetadata {
  currentTime?: number;
  duration: number;
  isLoaded: boolean;
}

export const KEYBOARD_MAPPING = ["1", "2", "3", "4", "q", "w", "e", "r", "a", "s", "d", "f", "z", "x", "c", "v"];

export interface MidiDevice {
  connection: string;
  id: string;
  manufacturer?: string;
  name: string;
  state: string;
  type: string;
}
